module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591e8949"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-quill-editor/editor.vue
// module id = 537
// module chunks = 0